!function() {
  class t extends HTMLElement {
    constructor() {
      super(), this.closeButton = this.querySelector("[data-close]"), this.sessionStorageName = this.dataset.name || "popUp", 
      this.isWishlistPopup = this.hasAttribute("data-wishlist"), this.wishlistDelay = parseInt(this.dataset.wishlistDelay) || 300, 
      this.wishlistDuration = parseInt(this.dataset.wishlistDuration) || 3e3, this.swat = null, 
      this.init();
    }
    init() {
      this.isWishlistPopup ? this.initWishlistPopup() : "true" !== sessionStorage.getItem(this.sessionStorageName) ? (this.classList.remove("hidden"), 
      this.closeButton && this.closeButton.addEventListener("click", this.handleClose.bind(this))) : this.hide();
    }
    initWishlistPopup() {
      this.hide(), this.wishlistCount = 0, this.originalText = this.querySelector("[data-popup-text]")?.textContent || this.textContent.trim(), 
      this.textElement = this.querySelector("[data-popup-text]") || this, this.isVisible = !1, 
      this.hideTimeout = null, this.setupSwymIntegration(), this.closeButton && this.closeButton.addEventListener("click", this.handleClose.bind(this));
    }
    setupSwymIntegration() {
      if (!0 !== Shopify.MBF.wishlistEnabled) return console.log("PopUp: Wishlist functionality is disabled, skipping Swym integration"), 
      void this.setupFallbackEventListeners();
      const t = Date.now(), i = () => {
        window.Swym && "function" == typeof window.Swym.registerComponent ? window.Swym.registerComponent(t => {
          this.swat = t, this.setupSwymEventListeners();
        }) : Date.now() - t < 3e4 ? setTimeout(i, 100) : (console.warn("PopUp: Swym utility did not become available within 30 seconds for popup component"), 
        this.setupFallbackEventListeners());
      };
      i();
    }
    setupSwymEventListeners() {
      this.swat && this.swat.evtLayer && this.swat.JSEvents ? this.swat.evtLayer.addEventListener(this.swat.JSEvents.addedToWishlist, t => {
        this.handleWishlistAdded(t);
      }) : (console.warn("PopUp: Swym objects not available for event listeners"), this.setupFallbackEventListeners());
    }
    setupFallbackEventListeners() {
      document.addEventListener("wishlist:added", this.handleWishlistAdded.bind(this)), 
      document.addEventListener("swym:addedtowishlist", this.handleWishlistAdded.bind(this));
    }
    handleWishlistAdded(t) {
      let i = "";
      t.detail && t.detail.d && t.detail.d.dt && t.detail.d.dt, this.wishlistCount++, 
      this.isVisible ? (this.updateWishlistText(), this.extendVisibility()) : setTimeout(() => {
        this.updateWishlistText(), this.show(), this.scheduleHide();
      }, this.wishlistDelay);
    }
    updateWishlistText() {
      let t = this.originalText;
      if (this.wishlistCount > 1 && (t += ` (${this.wishlistCount})`), this.textElement.querySelector) {
        (this.textElement.querySelector("[data-popup-text]") || this.textElement.querySelector(".text-md") || this.textElement).textContent = t;
      } else this.textElement.textContent = t;
    }
    scheduleHide() {
      this.hideTimeout && clearTimeout(this.hideTimeout), this.hideTimeout = setTimeout(() => {
        this.hide();
      }, this.wishlistDuration);
    }
    extendVisibility() {
      this.scheduleHide();
    }
    showWishlistNotification(t) {
      this.handleWishlistAdded(t);
    }
    handleClose() {
      this.isWishlistPopup ? (this.hideTimeout && (clearTimeout(this.hideTimeout), this.hideTimeout = null), 
      this.wishlistCount = 0) : sessionStorage.setItem(this.sessionStorageName, "true"), 
      this.hide();
    }
    show() {
      this.classList.remove("hidden", "opacity-0", "pointer-events-none"), this.classList.add("opacity-100"), 
      this.isVisible = !0;
    }
    hide() {
      this.classList.add("hidden", "pointer-events-none", "opacity-0"), this.classList.remove("opacity-100"), 
      this.isVisible = !1, this.isWishlistPopup && (this.wishlistCount = 0, this.hideTimeout && (clearTimeout(this.hideTimeout), 
      this.hideTimeout = null));
    }
  }
  customElements.get("pop-up") || customElements.define("pop-up", t);
}();